//IF YOU WANT TO INSERT A NEW "data-to-be-toggled", THIS CODE HANDLES ONLY SINGLE WORDS
//SO MAKE THE VALUE OF THE OPTION AND THE ATTR BE JUST ONE WORD
//EXAMPLE: NEWTYPE IS OK, NEW-TYPE WILL CAUSE ERRORS
//IF YOU WANT AN ELEMENT TO BE AVAILABLE FOR MORE THAN ONE TYPE OF OPTION
//THEN SEPARE THE TYPES WITH ";" LIKE THIS "data-to-be-toggled="filling;processing"
const initToggler = () => {
    const elementsToBeToggledArray = document.querySelectorAll("[data-to-be-toggled]");
    const togglersArray = document.querySelectorAll("[data-toggler]");
    togglersArray.forEach(toggler => {
        toggler.addEventListener("click", () => {
            elementsToBeToggledArray.forEach((element) => {
                if (element.getAttribute("data-to-be-toggled").split(";").includes(toggler.getAttribute("data-toggler").toLowerCase())) {
                    element.classList.toggle("active");
                }
            });
        });
    });
};
